'use client'
import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { setCookie } from '@/features/shared/utils/cookies'
import { getObjectEntries } from '@/features/shared/utils/types'
import { guestClientCookieAttributes } from '@shared/constants/cookies'
import { persistGuestAddress } from '@/features/account/services/GuestUser/utils'
import { type ValidAddress } from '@/features/account/services/Addresses/types'
import { type PendingCookies } from '@/app/_utils/getRscPendingCookies'

// next/headers cookies are read only during render and RSC has no response to
// attach Set-Cookie to, so the values are queued server side and written here.
export const CookiePersisterClient = ({
  cookies,
  guestAddress,
}: {
  cookies: PendingCookies
  guestAddress: ValidAddress | undefined
}) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    getObjectEntries(cookies).forEach(([name, value]) => {
      if (!value) return
      setCookie(name, value, guestClientCookieAttributes)
    })
  }, [cookies])

  useEffect(() => {
    // the guest address cookie is httpOnly, so persist it through the route (which also
    // reconciles the cache with the response), not js-cookie
    if (!guestAddress) return
    void persistGuestAddress(guestAddress, queryClient).catch(() => undefined)
  }, [guestAddress, queryClient])

  return null
}
